import React from 'react'
import {useIntl} from 'react-intl'
import {PageTitle} from '../../../_metronic/layout/core'
import {Navigate, Route, Routes} from 'react-router-dom'
import {DemontageListPage} from './DemontageListPage'

const DemontageWrapper = () => {
  const intl = useIntl()
  return (
    <>
      <PageTitle breadcrumbs={[
        {title: 'Véhicule à démonter', path: '#', isSeparator: false, isActive: true}
      ]}>Liste</PageTitle>
      <Routes>
        <Route
          path='/liste'
          element={
            <>
              <DemontageListPage/>
            </>
          }
        />

        <Route index element={<Navigate to='/demontage/liste'/>}/>
      </Routes>
    </>
  )
}

export {DemontageWrapper}
